import { Resources } from 'constants/resources';

import { AxiosError } from 'axios';
import { axios } from 'config/axios';
import { prepareGatewayBulkCreateSubmitValues } from 'pages/Gateways/GatewaysCreate/utils/prepareGatewayBulkCreateSubmitValues';
import { ErrorData } from 'types/embedded/error';
import { formatAxiosToHydraError } from 'utils/formatAxiosToHydraError';

export const createGatewaysBulk = (data: ReturnType<typeof prepareGatewayBulkCreateSubmitValues>) =>
  axios
    .post(`${Resources.Gateways}/bulk/create`, data, {
      headers: { Accept: 'application/ld+json' },
    })
    .catch((error: AxiosError<ErrorData>) => Promise.reject(formatAxiosToHydraError(error)));
